@import (reference) '../../../constants/spacing.module.less';

.modal-body {
  max-height: 545px;
  overflow: auto;
  padding: @space-16;
}

.modal-footer {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.loading-indicator-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .loading-indicator {
    height: 100px;
    width: 100px;
  }
}
